module.exports = __webpack_public_path__ + "img/wawa2_slide_1.0a9d0cb7.jpg";